/**
 * Aviso de Privacidad y Términos de Uso — v1.0 Piloto
 * Fuente única de verdad para las páginas /aviso-privacidad y /terminos,
 * el gate de aceptación y el registro auditado por versión.
 *
 * IMPORTANTE: cuando cambie el texto, sube TERMS_CURRENT_VERSION y todos
 * los usuarios verán el modal de re-aceptación en su próximo login.
 */

export const TERMS_CURRENT_VERSION = "1.0";
export const TERMS_VERSION_DATE = "26 de septiembre de 2026";
export const TERMS_VERSION_LABEL = "v1.0 — Piloto";

export const PILOT_WARNING = `Este es una versión temporal para el programa piloto, construido siguiendo la estructura legal aplicable en México, actualmente en fase de validación. No debe usarse como versión definitiva para usuarios con pago de suscripción activa ni para el público en general. Será reemplazado por la Versión 2.0 revisada por el área jurídica antes del lanzamiento comercial.`;

export const LEGAL_AUDIENCE = "Asesores del programa piloto de Co-Legal, previa aceptación expresa en la plataforma.";

export const PRIVACY_SECTIONS = [
  {
    id: "identidad",
    title: "1. Identidad y domicilio del Responsable",
    body: `Responsable: Leonardo Izquierdo Bernal, operando la plataforma "Co-Legal by BROKER-MEXICO.com" ("la Plataforma").
Domicilio: Nicolás San Juan 1617, Col. Del Valle, Alcaldía Benito Juárez, Ciudad de México.
Correo de contacto para temas de privacidad: privacidad@broker-mexico.prop.com`,
  },
  {
    id: "datos-recabados",
    title: "2. Datos personales que se recaban",
    body: `A través del uso de la Plataforma, se recaban los siguientes datos, según el documento o función utilizada:

• Datos de identificación: nombre completo, nacionalidad, estado civil, CURP, RFC, tipo y número de documento de identidad (INE/Clave de Elector, pasaporte, o documento migratorio).
• Datos de contacto: domicilio, correo electrónico, número de teléfono/celular.
• Datos del inmueble: dirección, folio real, tipo de uso, estado registral.
• Datos financieros: montos pactados, esquemas de pago, y en su caso, datos bancarios (institución, número de cuenta, CLABE) capturados exclusivamente para efectos de generar el documento correspondiente.
• Documentos de identificación PLD: información requerida conforme a la Ley Federal para la Prevención e Identificación de Operaciones con Recursos de Procedencia Ilícita, incluyendo la identificación del beneficiario controlador.
• Datos de uso: registros de inicio de sesión, documentos generados y validaciones solicitadas.
• Datos personales sensibles: la Plataforma no recaba, salvo mención expresa, datos personales sensibles en los términos definidos por la LFPDPPP (origen étnico, salud, religión, orientación sexual). Cuando algún documento requiera datos biométricos con fines notariales, dicho proceso ocurre directamente ante la Notaría correspondiente.`,
  },
  {
    id: "finalidades",
    title: "3. Finalidades del tratamiento",
    body: `Los datos se utilizan para:

Finalidades primarias (necesarias): Generar los documentos inmobiliarios; operar la cuenta del usuario y subusuarios; proveer capacitación contextual (Copiloto); facilitar la solicitud de validación jurídica/fiscal; y enviar códigos de acceso (OTP) o notificaciones operativas.

Finalidades secundarias: Actualmente, la Plataforma no utiliza los datos para fines de publicidad o mercadotecnia. De cambiar esto, se solicitará el consentimiento correspondiente.`,
  },
  {
    id: "transferencias",
    title: "4. Transferencias y encargados de tratamiento",
    body: `Para operar, los datos se comparten con:

• Emergent Labs Inc.: proveedor de infraestructura tecnológica, como encargado del tratamiento exclusivamente para almacenamiento y operación técnica.
• Twilio / Proveedores de mensajería: exclusivamente para el envío de códigos de seguridad SMS para el acceso a la cuenta.
• Profesionales de revisión (abogados/contadores): únicamente cuando el usuario solicite expresamente una validación en la Plataforma.
• Broktool: únicamente si el usuario utiliza el enlace de redirección hacia sus servicios (firma electrónica o buró de crédito) por acción directa y voluntaria.

No se venden ni comparten datos con terceros para publicidad.`,
  },
  {
    id: "arco",
    title: "5. Derechos ARCO",
    body: `El titular puede ejercer sus derechos de Acceso, Rectificación, Cancelación y Oposición (ARCO), o revocar su consentimiento, enviando su solicitud a privacidad@broker-mexico.prop.com, identificándose conforme a la ley.`,
  },
  {
    id: "seguridad",
    title: "6. Medidas de Seguridad y Privacidad de la Arquitectura (Piloto)",
    body: `Para garantizar la confidencialidad absoluta de los datos ingresados por los asesores, la Plataforma cuenta con las siguientes medidas técnicas implementadas:

• Aislamiento de Operaciones (Control de Acceso Basado en Roles): Existe un blindaje a nivel base de datos. Ningún usuario o subusuario puede ver, editar o eliminar operaciones, clientes o inmuebles creados por otros colegas. La visibilidad es exclusiva del creador del documento. La administración central no accede al contenido detallado de los contratos para fines ajenos al soporte técnico solicitado.
• Autenticación Reforzada: El acceso requiere validación de identidad obligatoria mediante códigos de un solo uso (OTP) enviados vía SMS (Twilio) o credenciales cifradas para cuentas máster, impidiendo accesos no autorizados.
• Enlaces Públicos Criptográficos: Los documentos compartidos externamente utilizan identificadores únicos de 128 bits (UUIDv4) no adivinables. Es matemáticamente imposible que un tercero intercepte operaciones de otros usuarios alterando las direcciones web.
• Criptografía y Sesiones Seguras: Los datos viajan bajo protocolos de cifrado en tránsito. Las sesiones de usuario están protegidas por tokens de seguridad de 256 bits (JWT rotados). Adicionalmente, la Plataforma se encuentra en proceso de implementación de cifrado en reposo a nivel de campo para datos sensibles como fase final antes de su lanzamiento comercial.`,
  },
  {
    id: "conservacion",
    title: "7. Conservación y Eliminación de los datos",
    body: `Los datos se conservan mientras la cuenta permanezca activa. Al solicitar la cancelación de la cuenta desde la configuración, el usuario entra en un periodo de gracia de 30 días donde el acceso se desactiva, pero la información se conserva temporalmente para evitar pérdidas accidentales. Cumplido este plazo, o el exigido por disposiciones fiscales/inmobiliarias, los datos se eliminan definitivamente.`,
  },
  {
    id: "cambios",
    title: "8. Cambios a este Aviso",
    body: `Los cambios sustanciales requerirán aceptación expresa del usuario dentro de la Plataforma antes de continuar utilizándola. El sistema registra la fecha y versión aceptada por cada cuenta.`,
  },
];

export const TERMS_SECTIONS = [
  {
    id: "naturaleza-servicio",
    title: "1. Naturaleza del servicio",
    body: `Co-Legal genera documentos inmobiliarios y ofrece capacitación contextual mediante un cuestionario. En esta etapa piloto (beta), la Plataforma puede contener errores, funciones en desarrollo o interrupciones.`,
  },
  {
    id: "naturaleza-documentos",
    title: "2. Naturaleza de los documentos generados",
    body: `Los documentos son borradores de apoyo, no constituyen asesoría legal ni fiscal. Se recomienda la validación por un profesional antes de la firma. Para el Contrato de Traspaso de Local Comercial, la validación es obligatoria dentro de la Plataforma. El asesor es el único responsable de verificar la exactitud de los datos, la identidad de las partes y el cumplimiento de la Ley Antilavado (LFPIORPI).`,
  },
  {
    id: "tipos-cuenta",
    title: "3. Tipos de Cuenta y Reglas de Acceso",
    body: `La Plataforma opera bajo tres esquemas de seguridad de acceso:

• Cuenta de Asesor Independiente: Registro y acceso exclusivo mediante validación telefónica (SMS OTP). El asesor es titular y responsable de su pago y operaciones.
• Cuenta de Inmobiliaria (Principal): Cuenta máster creada exclusivamente desde la administración central, con acceso primario vía correo electrónico. Es responsable del pago centralizado y tiene facultades para gestionar su equipo.
• Subusuario de Inmobiliaria: Agentes invitados por la Cuenta Principal. Su registro y acceso es estrictamente mediante validación telefónica (SMS OTP) para garantizar que las credenciales no sean compartidas. La Cuenta Principal tiene visibilidad de las operaciones de sus subusuarios, pero cada uno es responsable de la veracidad de lo que captura.

Vinculación con Google: Habilitada únicamente como método secundario de inicio de sesión para cuentas previamente verificadas. No es posible crear cuentas nuevas de asesor directamente mediante Google.`,
  },
  {
    id: "uso-aceptable",
    title: "4. Uso aceptable",
    body: `El usuario se obliga a no ingresar información falsa, fraudulenta o que simule operaciones inexistentes, utilizando la Plataforma exclusivamente para fines lícitos de su actividad inmobiliaria.`,
  },
  {
    id: "propiedad-intelectual",
    title: "5. Propiedad intelectual",
    body: `Los documentos generados con los datos capturados pertenecen al usuario y a las partes de la operación. La estructura, lógica condicional, arquitectura de software y banco de explicaciones (Copiloto) son propiedad exclusiva de Leonardo Izquierdo Bernal.`,
  },
  {
    id: "limitacion-responsabilidad",
    title: "6. Limitación de responsabilidad",
    body: `La Plataforma se ofrece "tal cual" durante esta etapa piloto. El titular de la Plataforma no será responsable por daños derivados del uso de documentos sin validación profesional, ni por interrupciones propias del periodo de prueba técnica.`,
  },
  {
    id: "vigencia-terminacion",
    title: "7. Vigencia y terminación de cuentas",
    body: `El administrador podrá suspender cuentas que incumplan estos Términos. El usuario puede cancelar su suscripción desde su perfil, lo cual detonará el periodo de gracia de 30 días detallado en el Aviso de Privacidad previo a la eliminación total de la cuenta.`,
  },
  {
    id: "jurisdiccion",
    title: "8. Jurisdicción",
    body: `Para la interpretación y cumplimiento de estos Términos, las partes se someten a las leyes aplicables y tribunales competentes de la Ciudad de México.`,
  },
  {
    id: "aceptacion-versiones",
    title: "9. Aceptación y Control de Versiones",
    body: `El uso de la Plataforma está estrictamente condicionado a la marcación de la casilla de aceptación de estos Términos y del Aviso de Privacidad. El sistema audita y registra de forma inmutable la versión exacta aceptada por el usuario al momento de su registro o actualización.`,
  },
];
